module.exports = "<router-outlet></router-outlet>\n<app-header ></app-header>\n<!-- <div class=\"space\"></div>\n -->\n<app-footer></app-footer>"